module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_vindeln-7c111964536f17bff148c38b280378f1.png";